<template>
  <div class="my_form">
    <el-dialog title="打卡异常明细" :visible.sync="visible" width="1000px" top='20vh' :before-close="onClose">
      <PTable :columns="columns" :loadData="loadData" ref="table" :showSize="false" >
        <template #realDutyTime="record">
          <div :class="record.row.realDutyTime ? '' : 'red'">{{ record.row.realDutyTime ? record.row.realDutyTime : '08:30(未打卡)' }}</div>
        </template>
        <template #realOffTime="record">
          <div :class="record.row.realOffTime ? '' : 'red'">{{ record.row.realOffTime ? record.row.realOffTime : '17:00(未打卡)' }}</div>
        </template>
        <template #remark="record">
          <div :class="record.row.isCardReplace ? 'blue' : 'red'">{{ record.row.isCardReplace ? '已补卡' : '未补卡' }}</div>
        </template>
      </PTable>
      <span slot="footer" class="dialog-footer">
      </span>
    </el-dialog>
  </div>
</template>

<script>
import PTable from '@/components/PTable';
export default {
  props: {
    visible: {
      type: Boolean,
      required: false
    },
    record: {
      type: Array,
      default: () => []
    }
  },
  components: {
    PTable
  },
  watch: {
    record: {
      handler() {
        if(this.$refs.table) this.$refs.table.refresh(true)
      },
      immediate: true,
      deep:true
    }
  },
  data() {
    return {
      columns: [
        {
          label: '基本信息',
          children: [
            {
              label: '序号',
              prop: 'index',
              width: 100,
              fixed: "left"
            },
            {
              label: '姓名',
              prop: 'name',
              // width: 100
            },
            {
              label: '部门',
              prop: 'deptName',
              // width: 100
            }
          ]
        },
        {
          label: '异常情况',
          children: [{
            label: '日期',
            prop: 'date',
            // width: 100
          },
          {
            label: '上班打卡时间',
            scopedSlots: 'realDutyTime',
            // width: 100
          },
          {
            label: '下班打卡时间',
            scopedSlots: 'realOffTime',
            // width: 100
          }
          ]
        },
        {
          label: '处理',
          children: [{
            label: '备注',
            scopedSlots: 'remark',
            // width: 100
          }
          ]
        }
      ],
      loadData: () => {
        return new Promise((resolve, reject) => {
            resolve({
              data: {
                totalCount: this.record.length,
                dataList: this.record
              }
            })
        })
      }
    };
  },
  methods: {
    onClose() {
      this.$emit('update:visible', false);
    },
    onDialogClose() {
      // 还好保留一个遮罩，直接移除
      const tag = document.querySelector('.checkList .v-modal');
      if (tag) tag.remove();
    }
  }
};
</script>
<style lang="scss" scoped>
  .red{
    color: red;
  }
  .blue{
    color: #00b8ff;
  }
</style>